import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import moment from 'moment'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import {
  sessionGetItemObj,
  sessionGetItemStr,
  sessionRemoveItem,
  sessionSetItemObj,
  sessionSetItemStr,
} from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import { previewFile } from '../../../utils/fileUtil'
import { downloadIncomeSubProjectVoucherListFile } from '../../../redux/actions/projectBasedItems'
import AddBlacklistForm from './AddBlacklistForm'
import { saveBlacklisted } from '../../../redux/actions/blacklist'
import ViewAddBlacklistForm from './ViewAddBlacklistForm'

export default function AddBlacklistWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const [considerResultSchema, setConsiderResultSchema] = useState()

  const isViewOnly = !!sessionGetItemStr('isViewOnly')
  // const blacklistedId = sessionGetItemStr('blacklistedId')
  const { blacklistedId, editMode } = sessionGetItemObj('blacklistedId')

  let history = useHistory()

  // const handleCallDelete = async () => {
  //   startLoading()
  //   setIsLoading(true)
  //   setIsError(false)

  //   try {
  //     const response = await deleteSubProjectIncomeRecord(blacklistedId)
  //     if (response) {
  //       notification.open('success', {
  //         title: globalMsgUtil.DELETE_SUCCESS,
  //       })
  //       setIsShowConfirmDelete(false)
  //       history.goBack()
  //     } else {
  //       setIsError(true)
  //     }
  //   } catch (e) {
  //     console.log('error', e)
  //     if (e?.response?.data) {
  //       console.log(e?.response?.data)
  //       setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
  //     } else {
  //       setIsError(globalMsgUtil.SET_IS_ERROR)
  //     }
  //     setIsShowConfirmDelete(false)
  //   }
  //   setIsLoading(false)
  //   doneLoading()
  // }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirm(false)
    try {
      let response = await saveBlacklisted(requestBody)

      if (response) {
        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })

        setFormSchema(response.model)
        setRequestBody()
        // sessionSetItemStr('blacklistedId', response.model.id)
        sessionSetItemObj('blacklistedId', { blacklistedId: response.model.id, editMode: editMode })

        setIsShowConfirm(false)
        setTimeout(() => {
          if (blacklistedId) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const formData = new FormData()

    formData.append('Id', blacklistedId || '')
    formData.append('blacklistType', data.blacklistType || '')
    formData.append('idCard', data.idCard || '')
    formData.append('personName', data.personName || '')
    formData.append('taxNumber', data.taxNumber || '')
    formData.append('juristicName', data.juristicName || '')
    formData.append('blacklistAbandonmentType', data.blacklistAbandonmentType || '')
    formData.append('blacklistStatus', data.blacklistStatus || '')
    formData.append('note', data.note || '')
    formData.append('startDate', moment(data.startDate).format('YYYY/MM/DD') || '')
    formData.append('endDate', moment(data.endDate).format('YYYY/MM/DD') || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('attachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    let master = considerResultSchema.values

    data.considerResult &&
      data.considerResult?.forEach((item, index) => {
        formData.set(`ConsiderResult[${index}].ProjectCode`, master[index].projectCode)
        formData.set(`ConsiderResult[${index}].ConsiderResult`, item)
        formData.set(`ConsiderResult[${index}].ProjectRelation`, master[index].relate)
      })

    // setRequest(formData)
    setRequestBody(formData)
    setIsShowConfirm(true)
  }

  const onPreview = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadIncomeSubProjectVoucherListFile(filePath)

      previewFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }
  // console.log('formSchema555', formSchema)
  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {!editMode && !formSchema?.disabled ? (
          <>
            <AddBlacklistForm
              schema={formSchema?.from}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              setIsEnableEdit={setIsEnableEdit}
              considerResultSchema={considerResultSchema}
              setConsiderResultSchema={setConsiderResultSchema}
              blacklistedId={blacklistedId}
            />
          </>
        ) : (
          <>
            <ViewAddBlacklistForm
              schema={formSchema?.from}
              register={register}
              setIsEnableEdit={setIsEnableEdit}
            />
          </>
        )}

        <div>
          <br />
          {!editMode && !formSchema?.disabled ? (
            <Row>
              {isError && <Message showIcon type="error" description={isError} />}
              <Col lg={12} md={12} sm={24} xs={24}></Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {!isViewOnly && !formSchema?.disabled && (
                  <>
                    <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
                    <CancelButton
                      onClick={() => {
                        sessionRemoveItem('blacklistedId')
                        history.goBack()
                      }}
                    >
                      ยกเลิก
                    </CancelButton>
                  </>
                )}
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                <Col lg={12} md={12} sm={24} xs={24}></Col>
                <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <CancelButton
                    onClick={() => {
                      sessionRemoveItem('blacklistedId')
                      history.goBack()
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </Col>
              </Row>
            </>
          )}
        </div>
      </Panel>

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => {
          setRequestBody()
          setIsShowConfirm(false)
        }}
        onConfirm={handleCallService}
      />
      {/* 
      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_DELETE_DOC_TITLE}
        show={isShowConfirmDelete}
        detail={globalMsgUtil.CONFIRM_DELETE_DOC_DETAIL}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCallDelete}
      /> */}
    </>
  )
}
